import { startOfDay } from "@/libs/date";

export type DatePickerViewBounds = {
  minDate?: Date;
  maxDate?: Date;
};

/**
 * Resolves which month the calendar should open on.
 *
 * Precedence: the selected `value` wins, then `defaultViewDate`, then today.
 * Only `defaultViewDate` is clamped to `bounds` — a selected value and the
 * today-fallback are returned untouched, so pickers that don't pass
 * `defaultViewDate` behave exactly as they did before this option existed.
 *
 * Clamping keeps the opening view inside the year list produced by
 * `getYearsForPicker(minDate, maxDate)`. Comparison is date-only.
 */
export function resolveInitialViewDate(
  value: Date | null | undefined,
  defaultViewDate: Date | undefined,
  bounds?: DatePickerViewBounds,
): Date {
  if (value != null) return value;
  if (defaultViewDate == null) return new Date();

  const target = startOfDay(defaultViewDate).getTime();

  const { minDate, maxDate } = bounds ?? {};
  if (minDate != null && target < startOfDay(minDate).getTime()) return minDate;
  if (maxDate != null && target > startOfDay(maxDate).getTime()) return maxDate;

  return defaultViewDate;
}
